class PlugBuyMoreSaveMore extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.tiers = [
            {min:1,max:1,off:0,label:'List price'},
            {min:2,max:3,off:0.05,label:'5% off list'},
            {min:4,max:5,off:0.10,label:'10% off list'},
            {min:6,max:Infinity,off:0.15,label:'15% off list'}
        ];
        this.activeTier = 0;
        this.elements = {
            qtyElement: document.getElementById(`Quantity-${this.sectionId}`),
            pricesContainer: document.querySelector(`#price-${this.sectionId}`),
            atcSubmit: document.querySelector(`#ProductSubmitButton-${this.sectionId}[data-atc-submit]`),
        };
        this.elements.atcPrice = this.elements.atcSubmit
            ? this.elements.atcSubmit.querySelector('[data-atc-price]')
            : null;
        this.removeListeners = this.initListeners();
        this.updateAtcPrice(this.activeTier);
    }

    disconnectedCallback() {
        if (typeof this.removeListeners === "function") {
            this.removeListeners();
        }
    }

    initListeners() {
        const inputs = this.querySelectorAll("input");
        const handleChange = (e) => {
            const inputId = e.target.id;
            const tier = Number(inputId.replace("bmsm_tier", ""));
            this.setTier(tier);
        };
        const handleQtyChange = (e) => {
            const value = e.target.value;
            const tier = this.getTierFromQty(value);
            const label = this.querySelector(`#bmsm_tier${tier} + label`);
            label.click();
            this.updateAtcPrice(tier);
        };
        const handleQtyInput = () => {
            this.updateAtcPrice(this.activeTier);
        };
        inputs.forEach((input) => {
            input.addEventListener("change", handleChange, false);
        });

        this.elements.qtyElement.addEventListener("change", handleQtyChange, false);
        this.elements.qtyElement.addEventListener("input", handleQtyInput, false);

        return () => {
            inputs.forEach((input) => {
                input.removeEventListener("change", handleChange, false);
            });
            this.elements.qtyElement.removeEventListener("change", handleQtyChange, false);
            this.elements.qtyElement.removeEventListener("input", handleQtyInput, false);
        };
    }

    getTierFromQty(qty) {
        const index = this.tiers.findIndex(tier => {
            return (
                qty >= tier.min && qty <= tier.max
            );
        });
        if (index === -1) {
            return 0;
        }
        return index;
    }

    getTier() {
        return this.activeTier;
    }

    setTier(tier) {
        this.activeTier = tier;
        this.updatePrice(tier);
        this.updateQuantity(tier);
        this.updateFooter(tier);
        this.updateAtcPrice(tier);
    }

    updateAtcPrice(tier) {
        const priceEl = this.elements.atcPrice;
        const submit = this.elements.atcSubmit;
        if (!priceEl || !submit) {
            return;
        }
        const unitPrice = Number(submit.dataset.unitPrice);
        if (!Number.isFinite(unitPrice)) {
            return;
        }
        const qty = Number(this.elements.qtyElement.value) || 0;
        const off = (this.tiers[tier] && this.tiers[tier].off) || 0;
        const totalCents = Math.round(unitPrice * (1 - off) * qty);
        priceEl.textContent = this.formatMoneyFromTemplate(totalCents, priceEl.textContent);
    }

    formatMoneyFromTemplate(cents, template) {
        const value = (cents / 100).toFixed(2);
        const match = String(template).match(/^([^0-9]*)([0-9,]+\.[0-9]{2}|[0-9,]+)(.*)$/);
        if (match) {
            return `${match[1]}${value}${match[3]}`;
        }
        return `$${value}`;
    }

    updatePrice(tier) {
        const prices = Array.from(this.elements.pricesContainer.querySelectorAll("[data-bmsm-tier]"));
        prices.forEach(price => {
            const priceTier = Number(price.dataset.bmsmTier);
            if (priceTier === tier) {
                price.classList.remove("hidden");
            } else {
                price.classList.add("hidden");
            }
        });
    }

    updateQuantity(tier) {
        const { min, max } = this.tiers[tier];
        const currentQuantity = this.elements.qtyElement.value;
        if (currentQuantity < min || currentQuantity > max) {
            this.elements.qtyElement.value = min;
        }
    }

    updateFooter(tier) {
        const currentQuantity = this.elements.qtyElement.value;
        const addMoreText = this.querySelector(".plug-bmsm-footer__add-more-text");
        const maxText = this.querySelector(".plug-bmsm-footer__max-discount-text");
        if (tier === 3) {
            addMoreText.classList.add("hidden");
            maxText.classList.remove("hidden");
        } else {
            addMoreText.classList.remove("hidden");
            maxText.classList.add("hidden");
            const nextTier = this.tiers[tier + 1];
            const more = nextTier.min - currentQuantity;
            addMoreText.querySelector("b:first-of-type").textContent = `${more}`;
            addMoreText.querySelector("b:last-of-type").textContent = `${nextTier.label}`;
            const unitWord = addMoreText.querySelector("[data-unit-word]");
            if (unitWord) unitWord.textContent = more === 1 ? "unit" : "units";
        }
    }
}

if (!customElements.get("plug-buy-more-save-more")) {
    customElements.define("plug-buy-more-save-more", PlugBuyMoreSaveMore);
}